import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { apiUrl } from 'app/common/url-resolver.service';
import { Observable } from 'rxjs';
import { SelectedData } from 'app/common/common/checkbox-groups/checkbox-groups.component';

export type FwdSettings = FwdFields & FwdChanges;

export type FwdFields = {
  fields: SelectedData;
};

export type FwdChanges = {
  changes: SelectedData;
};

@Injectable({ providedIn: 'root' })
export class InteractionFwdSettingsService {
  private readonly URL = apiUrl('tasks', 'fwd-settings');

  constructor(private http: HttpClient) {}

  get(): Observable<FwdSettings> {
    return this.http.get<FwdSettings>(this.URL);
  }

  update(setting: FwdFields | FwdChanges): Observable<void> {
    return this.http.put<void>(this.URL, setting);
  }
}
